import PopOver from 'chameleon/ui-stack/ui/base/popover';
import { Icon } from 'legacy-packages/ft-cb';
import React from 'react';

export const QuestionsPopoverContent = ({
  isQuizSummaryPage,
  renderComponentsWarningMessage,
  renderFRQMCQBothNotSelected,
  renderExclusionDaysWarningMessage,
}) => {
  const COMPONENTS_WARNING_MESSAGE =
    'Many questions cover just one component, so make sure you have at least as many questions as components you want to cover in the quiz.';
  const FRQ_MCQ_BOTH_NOT_SELECTED_MESSAGE =
    'Some components are only valid for MCQ or FRQ questions, not both. If you have included some of these, you may want to make sure you have requested both MCQ and FRQ questions for the quiz.';
  const QUESTIONS_TESTED_BY_SETS_MESSAGE =
    'Some components are largely tested by sets of questions. A component may not be covered if there is not room for a whole set in the quiz.';
  const EXCLUSION_DAYS_WARNING_MESSAGE =
    'If you have entered a day count for prior assigned questions, you may want to lower it or remove it if the quiz could not cover all components.';

  if (!isQuizSummaryPage) {
    return (
      <div class="text-base">
        <p>Consider the following to improve component coverage</p>
        <ul class="px-6">
          <li>{COMPONENTS_WARNING_MESSAGE}</li>
          <li>{FRQ_MCQ_BOTH_NOT_SELECTED_MESSAGE}</li>
          <li>{QUESTIONS_TESTED_BY_SETS_MESSAGE}</li>
          <li>{EXCLUSION_DAYS_WARNING_MESSAGE}</li>
        </ul>
      </div>
    );
  }
  return (
    <div class="text-base">
      <p>Consider the following to improve component coverage</p>
      <ul class="px-6">
        {renderComponentsWarningMessage && (
          <li className="py-5">{COMPONENTS_WARNING_MESSAGE}</li>
        )}
        {renderFRQMCQBothNotSelected && (
          <li className="py-5">{FRQ_MCQ_BOTH_NOT_SELECTED_MESSAGE}</li>
        )}
        <li className="py-5">{QUESTIONS_TESTED_BY_SETS_MESSAGE}</li>
        {renderExclusionDaysWarningMessage && (
          <li className="py-5">{EXCLUSION_DAYS_WARNING_MESSAGE}</li>
        )}
      </ul>
    </div>
  );
};

const QuestionTypesPopover = () => (
  <PopOver
    position="top-end"
    size="medium"
    buttonClassName="details-popover-btn"
    contentClassName="leading-normal"
    arrowPosition={{ x: '13', y: '-10' }}
    accessibility={{
      'aria-label': 'Question Types Details',
      'aria-describedby': 'filter-details-tooltip',
    }}
    trigger={
      <div className="details-label-icon">
        <Icon name="circle_info" size="1.2em" className="fill-current" />
      </div>
    }
  >
    <QuestionsPopoverContent />
  </PopOver>
);

export default QuestionTypesPopover;
